import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';
import { userCenterAPI } from '@/httpService/serviceApi';
const reqUrl = `${baseGrtURL}/api/grt-ai`;

export const url = {
    status: `${reqUrl}/course/status` //获取课件
};
//查询评阅状态
export function handleGetReviewStatus(data) {
    return hMacAjax.get(url.status, data);
}

// ==================== 智能体案例仿真评价工具（scene=3）====================
const evaluationUrl = `${userCenterAPI}/user/evaluation/v1`;
export const evaluationUrlMap = {
    // 提交评价（scene=3 案例仿真）
    submitEvaluation: `${evaluationUrl}/submit`,
    // 查询本人是否已评价（返回 data.evl_flag）
    evaluationStatus: `${evaluationUrl}/status`,
    // 业务配置（返回 data.evaluation_agent_open 控制评价入口显隐）
    businessConfig: `${userCenterAPI}/user/business/config/detail`
};

// 提交评价
export function handleSubmitEvaluation(data) {
    return hMacAjax.post(evaluationUrlMap.submitEvaluation, data);
}

// 查询本人是否已评价
export function handleGetEvaluationStatus(params) {
    return hMacAjax.get(evaluationUrlMap.evaluationStatus, params);
}

// 查询业务配置（评价开关）
export function handleGetBusinessConfig(params) {
    return hMacAjax.get(evaluationUrlMap.businessConfig, params);
}
